export default "__VITE_ASSET__BCn2K0tE__"